export const constitutionalQuotes = [
  {
    quote: "A government big enough to give you everything you want is strong enough to take everything you have.",
    author: "Thomas Jefferson"
  },
  {
    quote: "The Constitution is not an instrument for the government to restrain the people, it is an instrument for the people to restrain the government.",
    author: "Patrick Henry"
  },
  {
    quote: "Liberty, once lost, is lost forever.",
    author: "John Adams"
  },
  {
    quote: "They who can give up essential liberty to obtain a little temporary safety, deserve neither liberty nor safety.",
    author: "Benjamin Franklin"
  },
  {
    quote: "A republic, if you can keep it.",
    author: "Benjamin Franklin"
  }
];
